//angular imports
import { ChangeDetectionStrategy, Component, computed, signal, Signal } from '@angular/core';
import { ShowUserNotificationsMessage, HideUserNotificationsMessage } from '@app/components';
import { NotificationsStateChangedMessage } from '@app/core';
import { Messenger } from '@app/shared';

@Component({
  selector: 'notification-bell',
  standalone: false,
  templateUrl: './notification-bell.component.html',
  styleUrl: './notification-bell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationBellComponent {
  private notificeationStateChanged: Signal<NotificationsStateChangedMessage>;
  private isUserNotificationsOpen: boolean = false;

  public count = computed(() => {

    let msg = this.notificeationStateChanged();

    if(!msg) return 0;

    let notifications = msg.notificationState.notifications();
    return notifications.length;
  });

  constructor(private messenger: Messenger) {
    this.notificeationStateChanged = this.messenger.getSignal(NotificationsStateChangedMessage);
  }


  public openNotifications() {
    // Logic to open notifications can be added here
    if(!this.isUserNotificationsOpen) {
      this.isUserNotificationsOpen = true;
      this.messenger.send(new ShowUserNotificationsMessage());
    }else{
      this.isUserNotificationsOpen = false;
      this.messenger.send(new HideUserNotificationsMessage());
    }
  }
}
